import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: none;\n  @media only screen and (max-width: ", ") {\n    display: block;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  @media only screen and (max-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  min-height: ", ";\n  padding: ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FocusLock, { AutoFocusInside } from 'react-focus-lock';
import ScrollLock from 'react-scrolllock';
import ModalContainer from './ModalContainer';
import ModalOverlay from './ModalOverlay';
import ModalDialog from './ModalDialog';
import ModalCloseButton from './ModalCloseButton';
import ScrollView from './ScrollView';
import { breakpoints } from '@vds-core/theme';
import { calculateRem } from '@uie/javascript-style-helpers';
var propTypes = {
  /**
   * @ignore
   */
  customScroll: PropTypes.bool,

  /**
   * @ignore
   */
  ariaLabel: PropTypes.string.isRequired,

  /**
   * React components or HTML elements that will be in the ModalBody.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  closeButton: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /**
   * @ignore
   */
  showCloseButton: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /**
   * @ignore
   */
  hideCloseButton: PropTypes.bool,

  /**
   * @ignore
   */
  disableOutsideClick: PropTypes.bool,

  /**
   * @ignore
   */
  showModal: PropTypes.bool,

  /**
   * @ignore
   */
  opened: PropTypes.bool,

  /**
   * @ignore
   */
  toggleModal: PropTypes.func.isRequired,

  /**
   * @ignore
   */
  unmounted: PropTypes.bool,

  /**
   * @ignore
   */
  modalHeight: PropTypes.string,

  /**
   * @ignore
   */
  modalWidth: PropTypes.string,

  /**
   * @ignore
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),

  /**
   * @ignore
   */
  styleConfig: PropTypes.object,

  /**
   * @ignore
   */
  fullScreenDialog: PropTypes.bool,

  /**
   * @ignore
   */
  fixedCloseButton: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  ariaLabel: '',
  className: null,
  closeButton: undefined,
  showCloseButton: undefined,
  hideCloseButton: false,
  customScroll: false,
  disableOutsideClick: false,
  showModal: false,
  opened: false,
  unmounted: false,
  modalHeight: undefined,
  modalWidth: undefined,
  //1.0 Props
  viewport: 'desktop',
  fullScreenDialog: false,
  fixedCloseButton: false
};

var closeButton = function closeButton(props) {
  var closeButton = props.closeButton || props.showCloseButton; // If no closeButton passed at all, show Default Header Close Button

  if (typeof closeButton === 'undefined') {
    return /*#__PURE__*/React.createElement(ModalCloseButton, {
      onClick: props.toggleModal,
      fixedCloseButton: props.fixedCloseButton,
      styleConfig: props.styleConfig && props.styleConfig.modalCloseButton,
      isAppleDevice: props.isAppleDevice,
      unmounted: props.unmounted,
      keyPress: props.keyPress
    });
  } // If closeButton passed in is null, don't show any Header Close Button


  if (props.closeButton === null && (props.showCloseButton === undefined || props.showCloseButton === false)) {
    return null;
  } // If closeButton is anything else, show it as the Header Close Button


  return props.closeButton ? props.closeButton : props.showCloseButton;
};

var ModalDialogWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalDialogWrapper",
  componentId: "ov12ij-0"
})(_templateObject(), function (_ref) {
  var styleConfig = _ref.styleConfig;
  return styleConfig && styleConfig.minHeight || calculateRem(232);
}, function (_ref2) {
  var styleConfig = _ref2.styleConfig,
      viewport = _ref2.viewport;
  return styleConfig && styleConfig.calcPadding && styleConfig.calcPadding(viewport);
}, function (_ref3) {
  var styleConfig = _ref3.styleConfig;
  return styleConfig && styleConfig.mobilePadding && styleConfig.calcPadding && "\n  @media (max-width: ".concat(breakpoints.md, ") {\n    padding: ").concat(styleConfig.calcPadding('mobile'), ";\n  }\n  ");
}, function (_ref4) {
  var customScroll = _ref4.customScroll;
  return customScroll && "\n    \n    *::-webkit-scrollbar {\n      display: none;\n    }\n\n    * {\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n    }\n\n    @media only screen and (min-width: ".concat(breakpoints.md, ") {\n      ::-webkit-scrollbar {\n        display: none;\n      }\n        scrollbar-width: none;\n        -ms-overflow-style: none;\n    }\n\n    @media only screen and (max-width: ").concat(breakpoints.md, ") {\n      ::-webkit-scrollbar {\n        display: auto;\n      }\n        scrollbar-width: auto;\n        -ms-overflow-style: auto;\n    }\n    ");
});
var ScrollContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "ScrollContainer",
  componentId: "ov12ij-1"
})(_templateObject2(), breakpoints.md);
var NoScroll = /*#__PURE__*/styled.span.withConfig({
  displayName: "NoScroll",
  componentId: "ov12ij-2"
})(_templateObject3(), breakpoints.md);

var ModalBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalBase, _React$Component);

  var _super = _createSuper(ModalBase);

  function ModalBase() {
    var _this;

    _classCallCheck(this, ModalBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      modalHeight: 0
    });

    _defineProperty(_assertThisInitialized(_this), "calculateHeight", function (modalHeight) {
      _this.setState({
        modalHeight: modalHeight
      });
    });

    return _this;
  }

  _createClass(ModalBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ariaLabel = _this$props.ariaLabel,
          children = _this$props.children,
          className = _this$props.className,
          disableOutsideClick = _this$props.disableOutsideClick,
          showModal = _this$props.showModal,
          opened = _this$props.opened,
          toggleModal = _this$props.toggleModal,
          unmounted = _this$props.unmounted,
          hideCloseButton = _this$props.hideCloseButton,
          customScroll = _this$props.customScroll,
          modalHeight = _this$props.modalHeight,
          modalWidth = _this$props.modalWidth,
          isMobileDevice = _this$props.isMobileDevice,
          viewport = _this$props.viewport,
          styleConfig = _this$props.styleConfig,
          fullScreenDialog = _this$props.fullScreenDialog,
          fixedCloseButton = _this$props.fixedCloseButton,
          animationDistance = _this$props.animationDistance,
          colorConfig = _this$props.colorConfig,
          clickStream = _this$props.clickStream,
          analyticsTrack = _this$props.analyticsTrack,
          zIndex = _this$props.zIndex,
          id = _this$props.id;

      if (!showModal) {
        return null;
      }

      return /*#__PURE__*/React.createElement(ModalContainer, {
        id: id,
        showModal: showModal,
        isMobileDevice: isMobileDevice,
        zIndex: zIndex
      }, /*#__PURE__*/React.createElement(FocusLock, {
        returnFocus: true
      }, /*#__PURE__*/React.createElement(ScrollLock, {
        isActive: showModal && !isMobileDevice
      }, /*#__PURE__*/React.createElement(ModalOverlay, {
        disableOutsideClick: disableOutsideClick,
        onDismiss: toggleModal,
        showModal: showModal,
        opened: opened,
        unmounted: unmounted,
        styleConfig: styleConfig && styleConfig.modalOverlay,
        fullScreenDialog: fullScreenDialog
      }, /*#__PURE__*/React.createElement(ModalDialog, _defineProperty({
        modalHeight: modalHeight,
        modalWidth: modalWidth,
        "aria-label": ariaLabel,
        className: className,
        unmounted: unmounted,
        showModal: showModal,
        opened: opened,
        role: "dialog",
        tabIndex: 1,
        viewport: viewport,
        styleConfig: styleConfig && styleConfig.modalDialog,
        fullScreenDialog: fullScreenDialog,
        animationDistance: animationDistance,
        colorConfig: colorConfig,
        "data-analyticstrack": analyticsTrack,
        "data-clickstream": clickStream
      }, "modalHeight", this.state.modalHeight), !hideCloseButton && fixedCloseButton && closeButton(this.props), /*#__PURE__*/React.createElement(ModalDialogWrapper, {
        viewport: viewport,
        styleConfig: styleConfig && styleConfig.modalDialogWrapper,
        isMobileDevice: isMobileDevice,
        customScroll: customScroll
      }, !hideCloseButton && !fixedCloseButton && closeButton(this.props), customScroll ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollContainer, null, /*#__PURE__*/React.createElement(ScrollView, {
        calculateHeight: this.calculateHeight
      }, children)), /*#__PURE__*/React.createElement(NoScroll, null, children)) : children))))));
    }
  }]);

  return ModalBase;
}(React.Component);

ModalBase.defaultProps = defaultProps;
ModalBase.propTypes = propTypes;
/** @component */

export default ModalBase;